import React from 'react'
import "./Style.css"
import { FaFacebook } from "react-icons/fa";
import { RxLinkedinLogo } from "react-icons/rx";
import { LuInstagram } from "react-icons/lu";
import { NavLink } from 'react-router-dom';
const Footer = () => {
    return (
        <>
            <div className='bottom_footer'>
                <div className="container">
                    <div className="col-lg-12">
                        <div className="row">

                            <div className='col-lg-9 mr-auto ml-auto w-100'>
                                <p className='m-0 footer_ext'>
                                    We support
                                    <a href="https://tricityecowarriors.com/">
                                        <img
                                            src='/Images/Footer_image.png'
                                            alt=""
                                            layout="intrinsic"
                                        />
                                    </a>
                                    (I HATE POLYTHENE) Choose a Greener Future!
                                </p>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="Privacy-Policy-footer-section">
                        <div className="footer-links">
                            <NavLink to="/privacypolicy">Privacy Policy</NavLink>
                             <NavLink to="/termsandconditons">Terms & Conditions</NavLink>
                             <NavLink to="/howitwork">How It Works</NavLink>
                             <NavLink to="/contactus">Contact Us</NavLink>
                        </div>
                        <div className="social-icons">
                            <a href=" https://www.facebook.com/people/Shop-Saverz/61558498083427/">
                            <FaFacebook />

                            </a>
                            <a href="https://www.linkedin.com/company/shop-saverz">

                            <RxLinkedinLogo className='Footer-Middle-icons' />
                            </a>

                            <a href="https://www.instagram.com/shop.saverz">

                                
                            <LuInstagram />
                            </a>

                        </div>
                        <div className="copyright">
                            © 2025 Shop Saverz. All Rights Reserved.
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
export default Footer